import { render, staticRenderFns } from "./DefaultRestTimeDialog.vue?vue&type=template&id=4f88cf44&"
import script from "./DefaultRestTimeDialog.vue?vue&type=script&lang=js&"
export * from "./DefaultRestTimeDialog.vue?vue&type=script&lang=js&"
import style0 from "./DefaultRestTimeDialog.vue?vue&type=style&index=0&id=4f88cf44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports